module.exports = __webpack_public_path__ + "img/Frame-Portrait-Marilyn-Monroe.85f080b3.webp";